export default "__VITE_ASSET__LQbhFBOx__"